/**
 * @fileoverview ProcessingButton component for the Storyteller web application.
 * Displays a processing button with a loader icon.
 *
 * @example
 * // Basic usage
 * <ProcessingButton />
 */

import config from '../../config'
import css from './ProcessingButton.module.css'

/**
 * @function ProcessingButton
 * @description Component for displaying a processing button with a loader icon.
 * @param {ProcessingButtonProps} props - The props for the ProcessingButton component.
 * @returns {JSX.Element} The ProcessingButton component.
 */

export function ProcessingButton() {
    return (
        <div className={css.container}>
            <div className={css.processing_outside}>
                <button
                    data-testid="progress-button"
                    disabled
                    className={`${css.button} ${css.processing}`}
                >
                    <img
                        alt="progress"
                        className={css.loader}
                        src={config.s3.getStaticURL('loader.svg')}
                    />
                </button>
            </div>
        </div>
    )
}
